export default __webpack_public_path__ + "static/media/logo-de-estilo-las-yo.4e7ee944.jpeg";